import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const AiBotChatIcon = ({ height, viewBox, width, color, ...rest }) => {
    return (
        <SvgIcon width={width} height={height} viewBox={viewBox} {...rest}>
            <path
                d="M13.82,6.18v-1.45c0-.8-.65-1.45-1.45-1.45h-2.18c0-1.21-.97-2.18-2.18-2.18s-2.18.97-2.18,2.18h-2.18c-.8,0-1.45.65-1.45,1.45v1.45c-1.21,0-2.18.97-2.18,2.18s.97,2.18,2.18,2.18v2.91c0,.8.65,1.45,1.45,1.45h8.73c.8,0,1.45-.65,1.45-1.45v-2.91c1.21,0,2.18-.97,2.18-2.18s-.97-2.18-2.18-2.18ZM4.73,8c0-.6.49-1.09,1.09-1.09s1.09.49,1.09,1.09-.49,1.09-1.09,1.09-1.09-.49-1.09-1.09ZM10.91,12h-5.82v-1.45h5.82v1.45ZM10.18,9.09c-.6,0-1.09-.49-1.09-1.09s.49-1.09,1.09-1.09,1.09.49,1.09,1.09-.49,1.09-1.09,1.09Z"
                fill={color}
            />
        </SvgIcon>
    );
};

AiBotChatIcon.propTypes = {
    height: string,
    viewBox: string,
    width: string,
    color: string,
};

AiBotChatIcon.defaultProps = {
    height: '16',
    viewBox: '0 0 16 16',
    width: '16',
    color: `${MIGRATED_COLORS.orange}`,
};

export default AiBotChatIcon;
